import React, { useState } from "react";
import { enqueueSnackbar } from "notistack";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import NotesIcon from '@mui/icons-material/Notes';
import SaveIcon from '@mui/icons-material/Save';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

export function NuevoEstructuraAgentesForm({ onCancel, onSave }) {
  const [periodo, setPeriodo] = useState("");
  const [observacion, setObservacion] = useState("");
  const [mostrarConfirmacion, setMostrarConfirmacion] = useState(false);
  const [error, setError] = useState("");

  const valorFechaPeriodo = periodo ? `${periodo}-01` : "";

  const handlePeriodoDateChange = (e) => {
    const fecha = e.target.value;
    setPeriodo(fecha ? fecha.slice(0, 7) : "");
  };

  const formatearPeriodoMesAnio = (periodoTexto) => {
    if (!periodoTexto) return "";
    const [anio, mes] = periodoTexto.split("-");
    const fecha = new Date(Number(anio), Number(mes) - 1, 1);
    return fecha.toLocaleDateString("es-EC", { month: "long", year: "numeric" });
  };

  const handleSolicitarGuardar = () => {
    if (!periodo || !observacion.trim()) {
      setError("Debe seleccionar período y escribir una observación.");
      enqueueSnackbar("Debe seleccionar período y escribir una observación.", { variant: "error" });
      return;
    }
    setError("");
    setMostrarConfirmacion(true);
  };

  const handleConfirmarGuardar = () => {
    onSave({ periodo, observacion: observacion.trim() });
    setMostrarConfirmacion(false);
  };

  return (
    <div className="bg-white border border-gray-200 rounded-2xl shadow-lg overflow-hidden">
      <div className="px-6 py-5 border-b border-gray-200 bg-gradient-to-r from-indigo-50 to-blue-50">
        <h2 className="text-xl font-bold text-gray-800">Nueva estructura de agentes</h2>
        <p className="text-sm text-gray-500 mt-1">Complete los campos para crear un nuevo registro</p>
      </div>

      <div className="p-6 grid grid-cols-1 md:grid-cols-2 gap-5">
        <div>
          <label className="text-sm font-semibold text-gray-700 mb-2 flex items-center gap-1">
            <CalendarMonthIcon sx={{ fontSize: 18 }} /> Período
          </label>
          <input
            type="date"
            value={valorFechaPeriodo}
            onChange={handlePeriodoDateChange}
            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:border-indigo-500 focus:ring-indigo-200 transition-all bg-white"
          />
          {periodo && (
            <p className="mt-2 text-xs text-gray-500">
              Período seleccionado: {formatearPeriodoMesAnio(periodo)}
            </p>
          )}
        </div>

        <div>
          <label className="text-sm font-semibold text-gray-700 mb-2 flex items-center gap-1">
            <NotesIcon sx={{ fontSize: 18 }} /> Observación
          </label>
          <textarea
            value={observacion}
            onChange={(e) => setObservacion(e.target.value)}
            rows={5}
            placeholder="Ingrese la observación..."
            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:border-indigo-500 focus:ring-indigo-200 transition-all bg-white resize-none"
          />
        </div>
      </div>

      {error && <p className="px-6 pb-2 text-sm text-red-600 font-medium">{error}</p>}

      <div className="px-6 pb-6 flex justify-end gap-3">
        <button
          onClick={onCancel}
          className="inline-flex items-center gap-2 px-5 py-3 rounded-xl border border-gray-300 text-gray-700 font-semibold hover:bg-gray-50 transition-all"
        >
          <ArrowBackIcon sx={{ fontSize: 18 }} /> Volver
        </button>
        <button
          onClick={handleSolicitarGuardar}
          className="inline-flex items-center gap-2 px-5 py-3 rounded-xl bg-gradient-to-r from-indigo-600 to-blue-600 text-white font-semibold hover:from-indigo-700 hover:to-blue-700 transition-all shadow"
        >
          <SaveIcon sx={{ fontSize: 18 }} /> Guardar
        </button>
      </div>

      {mostrarConfirmacion && (
        <div className="fixed inset-0 bg-black/30 flex items-center justify-center z-50 px-4">
          <div className="bg-white w-full max-w-md rounded-2xl shadow-2xl border border-gray-200 p-6">
            <div className="flex items-center gap-2 mb-2 text-amber-600">
              <HelpOutlineIcon sx={{ fontSize: 20 }} />
              <h3 className="font-bold text-gray-800">Confirmación</h3>
            </div>
            <p className="text-sm text-gray-600 mb-5">¿Está seguro de crear esto?</p>
            <div className="flex justify-end gap-3">
              <button
                onClick={() => setMostrarConfirmacion(false)}
                className="px-4 py-2 rounded-lg border border-gray-300 text-gray-700 font-semibold hover:bg-gray-50"
              >
                Cancelar
              </button>
              <button
                onClick={handleConfirmarGuardar}
                className="px-4 py-2 rounded-lg bg-indigo-600 text-white font-semibold hover:bg-indigo-700"
              >
                Sí, crear
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
